import React, { useMemo } from 'react';
import { Container } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { Line } from 'react-chartjs-2';
import CalendarClockIcon from 'mdi-react/CalendarClockIcon';
import EmailCheckOutlineIcon from 'mdi-react/EmailCheckOutlineIcon';
import EmailOpenOutlineIcon from 'mdi-react/EmailOpenOutlineIcon';
import t, { partial } from '../../util/translation/translation';
import { getBaseDateTime } from '../../util/date-and-time';
import FormCard from '../../shared/components/custom/FormCard';

const StatCell = ({ icon: Icon, title, value, isLast }) => (
  <div
    style={{
      minWidth: 0,
      paddingRight: isLast ? 0 : 12,
      borderRight: isLast ? 'none' : '1px solid #eee',
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 26,
        height: 26,
        borderRadius: '50%',
        background: '#eef2fb',
        marginBottom: 6,
      }}
    >
      <Icon size={15} color="#3b6cf6" />
    </div>
    <div style={{ fontSize: 18, fontWeight: 700, lineHeight: 1.2 }}>
      {value}
    </div>
    <small className="text-muted">{title}</small>
  </div>
);

const PushData = () => {
  const { state: messageState } = useLocation();
  const s = partial('shared');
  const mappedPushStat = messageState?.mappedPushStat;
  const rawLabels = mappedPushStat?.labels;
  const chartData = useMemo(() => {
    const labels = rawLabels || [];
    return {
      labels: labels.map((label) => moment(label.date).format('DD.MM. HH')),
      datasets: [
        {
          label: t('InsightPage.open'),
          data: labels.map((ds) => ds.views),
          backgroundColor: '#87BEFD',
          borderColor: '#0469DC',
        },
      ],
    };
  }, [rawLabels]);

  if (!mappedPushStat) {
    return (
      <Container>
        <FormCard title={s('Statistics')}>
          <p className="text-muted mb-0">{s('somethingWentWrong')}</p>
        </FormCard>
      </Container>
    );
  }

  const { success_count, opened_count, openedPercentage } = mappedPushStat;

  return (
    <Container>
      <FormCard title={s('Statistics')} bodyClassName="form-card__body--flush">
        <div style={{ padding: '16px 20px' }}>
          <div
            style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}
          >
            <StatCell
              icon={CalendarClockIcon}
              title={t('shared.sent')}
              value={getBaseDateTime(messageState?.createdAt)}
            />
            <StatCell
              icon={EmailCheckOutlineIcon}
              title={t('InsightPage.sent')}
              value={success_count}
            />
            <StatCell
              icon={EmailOpenOutlineIcon}
              title={t('InsightPage.open')}
              value={`${opened_count} (${openedPercentage}%)`}
              isLast
            />
          </div>
        </div>
        <hr className="m-0" />
        <div className="p-3">
          {rawLabels?.length > 0 ? (
            <Line data={chartData} />
          ) : (
            <p className="text-muted mb-0">{s('noData')}</p>
          )}
        </div>
      </FormCard>
    </Container>
  );
};

export default PushData;
